
import React, { useRef, useState } from "react";
import useOutsideClick from "../Hooks/useClickOutside";
import { useRole } from "../context/RoleContext";
import { useLoggedInUser } from "../context/LoggedUser";
const EmailModalForLeads = ({
  lead,
  onSubmit,
  onClose,
  loading,
}) => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [placeholders, setPlaceholders] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const { role } = useRole();
  const { company, loggedInUser } = useLoggedInUser();

  const handleSelectMailType = (type) => {
    let preFilledSubject = "";
    let preFilledMessage = "";
    setSelectedType(type);

    if (type === "intro") {
      preFilledSubject = "Introduction and Welcome";
      preFilledMessage = `Dear ${lead?.name},\n\nThank you for your interest in our services. We are excited to connect with you and explore how we can work together. Please feel free to reach out for any inquiries.\n\nLooking forward to your response.`;
    } else if (type === "follow_up") {
      preFilledSubject = "Follow-up on Previous Conversation";
      preFilledMessage = `Dear ${lead?.name},\n\nI’m following up regarding our previous conversation. We would love to hear your thoughts and assist you further.\n\nPlease let us know if you have any questions or updates.`;
    } else if (type === "custom") {
      preFilledSubject = "";
      preFilledMessage = "";
    }

    setSubject(preFilledSubject);
    setMessage(preFilledMessage);

    // Detect placeholders in message
    const matches = preFilledMessage.match(/\[.*?\]/g) || [];
    const keys = matches.map((m) => m.slice(1, -1));
    setPlaceholders(keys);
  };

  const handlePlaceholderChange = (key, value) => {
    const updatedMessage = message.replace(new RegExp(`\\[${key}\\]`, "g"), value);
    setMessage(updatedMessage);
  };

  const fixedSignature = `\n\nSincerely,\n${loggedInUser?.name} (${role})\n${loggedInUser?.email}\n${company || "[Your Company Name]"}`;

  const closeref = useRef(null);
  useOutsideClick(closeref, onClose);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      {loading ? (
        <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl p-6">Loading...</div>
      ) : (
        <div
          ref={closeref}
          className="bg-white rounded-lg shadow-lg w-full max-w-2xl max-h-[80vh] overflow-y-auto p-6"
        >
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Send Email to {lead?.name}
          </h2>

          {/* Select Type */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Select Email Type</label>
            <select
              value={selectedType}
              onChange={(e) => handleSelectMailType(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg text-sm"
            >
              <option value="" disabled>-- Select Type --</option>
              <option value="intro">Intro</option>
              <option value="follow_up">Follow Up</option>
              <option value="custom">Custom</option>
            </select>
          </div>

          {/* Placeholder Inputs */}
          {placeholders.length > 0 && (
            <div className="mb-4">
              <h3 className="text-sm font-medium text-gray-800 mb-2">Fill in the placeholders:</h3>
              {placeholders.map((key, index) => (
                <div key={index} className="mb-2">
                  <label className="block text-sm font-medium text-gray-700">{key.replace(/_/g, " ")}:</label>
                  <input
                    type="text"
                    onChange={(e) => handlePlaceholderChange(key, e.target.value)}
                    className="w-full px-4 py-2 border rounded-lg text-sm"
                  />
                </div>
              ))}
            </div>
          )}

          {/* Subject */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Subject</label>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg text-sm"
              placeholder="Enter email subject"
            />
          </div>

          {/* Message */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Message</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows="5"
              className="w-full px-4 py-2 border rounded-lg text-sm"
              placeholder="Enter email message"
            />
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-2">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              onClick={() => onSubmit(subject, message + fixedSignature)}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Send
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmailModalForLeads;
